import { FormModel } from '../core/form-model.class';
import { AccountActivationDTO } from './account-activation.dto';

export class AccountActivationFormModel extends FormModel(AccountActivationDTO) {
  public labels: any = {
    password: 'Nouveau mot de passe',
    confirmPassword: 'Confirmation du nouveau mot de passe',
  };
}